<template>
  <b-container fluid style='max-width: 900px;'>
    <b-row class="vh-100 text-center" align-v="center">
      <router-view :profile="profile" :user="user"/>
    </b-row>
  </b-container>
</template>

<script>
export default {
  props: ['profile', 'user']
}
</script>

<style>

</style>
